import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  // www → non-www soft redirect (Google prefers a single canonical host)
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.host.startsWith("www.")) {
      const noWww = window.location.href.replace("://www.", "://");
      window.location.replace(noWww);
    }
  }, []);

  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/nettoyage-gouttieres-martinique" element={<ServiceDetailPage slug="nettoyage-gouttieres-martinique" />} />
          <Route path="/lessivage-sols-martinique" element={<ServiceDetailPage slug="lessivage-sols-martinique" />} />
          <Route path="/plots-solaires-led-martinique" element={<ServiceDetailPage slug="plots-solaires-led-martinique" />} />
          <Route path="/nez-de-marches-photoluminescents-martinique" element={<ServiceDetailPage slug="nez-de-marches-photoluminescents-martinique" />} />
          <Route path="/photoluminescence-martinique" element={<ServiceDetailPage slug="photoluminescence-martinique" />} />
          <Route path="/depoussierage-hauteur-martinique" element={<ServiceDetailPage slug="depoussierage-hauteur-martinique" />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster
          theme="dark"
          position="top-right"
          richColors
          toastOptions={{
            style: {
              background: "#101010",
              border: "1px solid rgba(157,235,48,0.25)",
              color: "#fff",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
